// Constants
/**
 * The type of preview that can be shown for a task
 * TODO: Move this into the common enumerations file
 */ export var TaskPreviewType = /*#__PURE__*/ function(TaskPreviewType) {
    TaskPreviewType["Automatic"] = "automatic";
    TaskPreviewType["CheckList"] = "checklist";
    TaskPreviewType["Description"] = "description";
    TaskPreviewType["NoPreview"] = "noPreview";
    TaskPreviewType["Reference"] = "reference";
    return TaskPreviewType;
}({});
/**
 * The kind of task indicating its source or nature
 */ export var TaskKind = /*#__PURE__*/ function(TaskKind) {
    TaskKind["Planner"] = "planner";
    TaskKind["ToDo"] = "todo";
    return TaskKind;
}({});
